// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(720deg);
	}
}

.spinner {
	animation: spin 1.2s ease-in-out infinite;
	transform-origin: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/atoms/Spinner/spinner.css"],"names":[],"mappings":"AAAA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,yCAAyC;CACzC,wBAAwB;AACzB","sourcesContent":["@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(720deg);\n\t}\n}\n\n.spinner {\n\tanimation: spin 1.2s ease-in-out infinite;\n\ttransform-origin: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
